var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 4.808L13.193 3.75 9 7.943 4.808 3.75 3.75 4.808 7.943 9 3.75 13.193l1.058 1.057L9 10.058l4.193 4.193 1.057-1.057L10.058 9l4.193-4.192z"
  })));
}
export default SvgCloseIcon;